import { Link, useNavigate } from "react-router-dom";
import { App, fullRoutes } from "@songtradr-sso/shared/common";
import { Flex } from "@songtradr-sso/shared/frontend";
import { A, BackButton, Divider } from "@songtradr/design-language";
import {
  BackButtonContainer,
  Footer,
  HiddenHeaderSpacer,
  Props,
  Wrapper,
  text,
} from "./PageContainer.Parts";

export const PageContainer = ({
  children,
  header,
  background,
  floatTop = false,
  backButton = false,
  changeWorkspaceButton = false,
}: Props) => {
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    if (typeof backButton === "function") backButton();
    else navigate(-1);
  };

  return (
    <Wrapper $floatTop={floatTop} $background={background}>
      {backButton && (
        <BackButtonContainer>
          <BackButton onClick={handleBackButtonClick} />
        </BackButtonContainer>
      )}
      <Flex $flow="column" $gap="3rem" $maxWidth="500px" $fullWidth>
        {header}
        {children}
        <HiddenHeaderSpacer>{header}</HiddenHeaderSpacer>
      </Flex>
      <Footer>
        {text.copyright.replace("{year}", new Date().getFullYear().toString())}
        {changeWorkspaceButton && (
          <>
            <Divider $direction="vertical" />
            <A as={Link} to={fullRoutes[App.Core].base}>
              {text.changeWorkspace}
            </A>
          </>
        )}
      </Footer>
    </Wrapper>
  );
};
